export namespace MagicStrings {

  export const SignalRGroupNameFirstSectionEmployee: string = 'Employee-';
  export const SignalRGroupNameFirstSectionBranch: string = 'Branch-';
  export const SignalRGroupNameFirstSectionCompany: string = 'Company-';
  export const SignalRGroupNameFirstSectionUser: string = 'User-';
  export const SignalRMapHubSecondSection: string = 'signalrhub';
  export const JoinGroup: string = 'JoinGroup';

  export const LeaveGroup: string = 'LeaveGroup';
  export const SignalRGroupNameFirstSectionForUsersThatAcceptOrRejectRequestPermissionNotifications = 'UsersThatAcceptOrRejectRequestPermissionNotifications-';

  export const SignalRGroupNameFirstSectionForUserThatReceiveAcceptOrReject = 'UserThatReceiveAcceptOrReject-';
  export const SignalRGroupNameRequestPermissionNotificationId = '-RequestPermissionNotificationId-';

  export const NewBookingCRUDOperation: string = 'NewBookingCRUDOperation';
  export const NewGymMemberAttendViaFingerprintOperation: string = 'NewGymMemberAttendViaFingerprintOperation';

  export const NewTransactionCRUDOperation: string = 'NewTransactionCRUDOperation';

  export const NewGymMembershipAttendanceCRUDOperation: string = 'NewGymMembershipAttendanceCRUDOperation';

  export const NewGiftCardInformationCRUDOperation: string = 'NewGiftCardInformationCRUDOperation';

  export const NewGymMembershipCRUDOperation: string = 'NewGymMembershipCRUDOperation';


  export const NewReplyRequestPermissionNotification: string = 'NewReplyRequestPermissionNotification';
  export const NewClientNumberInQueue: string = 'NewClientNumberInQueue';



  export const NewRequestPermissionNotificationCRUDOperation: string = 'NewRequestPermissionNotificationCRUDOperation';

  export const NewClientBalanceCRUDOperation: string = 'NewClientBalanceCRUDOperation';

  export const NewChangeInClientsCodes: string = 'NewChangeInClientsCodes';
  export const NewChangeInActivitiesCodes: string = 'NewChangeInActivitiesCodes';

}
